import { useRef, useState, type JSX } from "react";
import { collapseSection, expandSection } from "../../utils/collaple-expand-utils";
import { RefFAQContainer, RefFAQContainerContent, RefFAQContainerHeader } from "./FAQPrivateArea.styles";
import { V3HeadlineH4 } from "../Typography";
import { ChevronRotatePositioner } from "../ReusableStyledComponents/ChevronRotatePositioner";
import { V3IconChevronDown } from "../Icons";
import { VerticalSpacing } from "../VerticalSpacing";

interface FAQPrivateAreaProps {
    headerText: string;
    body: JSX.Element;
}

export const FAQPrivateArea = ({ headerText, body }: FAQPrivateAreaProps) => {
    const [panelOpen, setPanelOpen] = useState(false);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const contentEl = useRef<HTMLDivElement | null>(null);

    const handleOpen = () => {
        if (!contentEl.current) return;

        if (!panelOpen) {
            expandSection(setPanelOpen, setIsTransitioning, contentEl.current);
        } else {
            collapseSection(setPanelOpen, setIsTransitioning, contentEl.current);
        }
    };

    return (
        <RefFAQContainer onClick={!panelOpen ? handleOpen : undefined}>
            <RefFAQContainerHeader onClick={handleOpen}>
                <div>
                    <V3HeadlineH4>{headerText}</V3HeadlineH4>
                </div>
                <ChevronRotatePositioner $panelOpen={panelOpen || (!panelOpen && isTransitioning)}>
                    <V3IconChevronDown />
                </ChevronRotatePositioner>
            </RefFAQContainerHeader>
            <RefFAQContainerContent ref={contentEl} $noCursor={panelOpen}>
                <VerticalSpacing bottom={24}>{body}</VerticalSpacing>
            </RefFAQContainerContent>
        </RefFAQContainer>
    );
};
